import React, { FC } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { FormField } from '../../models/training.models';
import { palette } from '../../theme';

interface TextFieldComponentProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TextFieldComponent: FC<TextFieldComponentProps> = ({ field, value, onChange, disabled = false }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {field.name}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder="Short answer text box"
        variant="outlined"
        sx={{
          bgcolor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: palette.divider,
            },
          },
        }}
      />
    </Box>
  );
};

export default TextFieldComponent;
